import { Factory, belongsTo } from 'miragejs'

export default Factory.extend({
  assignmentUuid() {
    return this.id
  },

  // out of 5
  score() {
    return 4
  },

  wordsPerMinute() {
    return 35
  },

  comments() {
    return 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
  },

  student: belongsTo(),
})
